import { render } from "./AdminSingleAddSessComp.vue?vue&type=template&id=c0f69b00&scoped=true"
import script from "./AdminSingleAddSessComp.vue?vue&type=script&lang=js"
export * from "./AdminSingleAddSessComp.vue?vue&type=script&lang=js"

import "./AdminSingleAddSessComp.vue?vue&type=style&index=0&id=c0f69b00&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f69b00"]])

export default __exports__